import React from 'react'

export default function Refunded() {
  return (
    <div>
      <div className="row-bot" style={{ display: 'block' }}>
        <div className="text-border">REFUNDED</div>
      </div>
    </div>
  )
}
